import { useVariant } from '@calendly/feature-check-react'

import { useNotetakerUpsellUIVisible } from 'hooks/notetaker_visibility'

const NOTETAKER_ET_TOGGLE_EXPERIMENT_KEY = 'growth_upsell_notetaker_in_et_creation'

export const NOTETAKER_ET_TOGGLE_VARIANTS = {
  CONTROL: 'control',
  VARIANT_1: 'variant_1',
  VARIANT_2: 'variant_2',
}

export const useNotetakerEtToggleExperimentVariant = () => {
  const { isVisible: upsellUiVisible, isLoading: isUpsellUiVisibilityLoading } = useNotetakerUpsellUIVisible()
  const shouldTrack = !isUpsellUiVisibilityLoading && upsellUiVisible
  const variant = useVariant(NOTETAKER_ET_TOGGLE_EXPERIMENT_KEY, shouldTrack)

  return shouldTrack ? variant : undefined
}

export const isNotetakerEtToggleEnabled = (variant) => (
  [
    NOTETAKER_ET_TOGGLE_VARIANTS.VARIANT_1,
    NOTETAKER_ET_TOGGLE_VARIANTS.VARIANT_2
  ].includes(variant)
)
